/**
 * While set, the Daily Reward page skips its auto-claim so the daily bonus is left for the
 * auto-promo popup on home to claim (otherwise both fire /claim and the second one fails).
 * Set before the post-login redirect to home; cleared once home mounts.
 *
 * Safety net: also auto-clears after a timeout. The home clear depends on the lazy popup chunk
 * mounting there — if it loads late or the user leaves home first, the flag would stick and the
 * Daily Reward page would keep skipping its claim (fake success, no /claim call).
 */
const CLAIM_PENDING_TTL_MS = 10_000;

let claimPending = false;
let expiryTimer: ReturnType<typeof setTimeout> | null = null;

export function setAutoPromoClaimPending(): void {
  claimPending = true;
  if (expiryTimer) clearTimeout(expiryTimer);
  expiryTimer = setTimeout(() => {
    claimPending = false;
    expiryTimer = null;
  }, CLAIM_PENDING_TTL_MS);
}

export function clearAutoPromoClaimPending(): void {
  claimPending = false;
  if (expiryTimer) {
    clearTimeout(expiryTimer);
    expiryTimer = null;
  }
}

export function isAutoPromoClaimPending(): boolean {
  return claimPending;
}
